import ReactPixel from 'react-facebook-pixel';

const PIXEL_ID = '1597432318202516';

export const initPixel = () => {
  const options = {
    autoConfig: true,
    debug: true, // turn false in production
  };

  ReactPixel.init(PIXEL_ID, undefined, options);
  ReactPixel.pageView();
};

export const trackEvent = (event, data) => {
  ReactPixel.track(event, data);
};